import UserStore from '../../stores/UserStore';
import * as moment from 'moment';

class Timer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid()
        };
    }

    render() {
        var timestamp = moment.utc(this.props.timestamp);
        var now = moment().utc();
        var diff = moment.utc(now.diff(timestamp))
        var dur = moment.duration(now.diff(timestamp));

        var result = diff.format("HH:mm:ss");

        if (dur.asDays() >= 1) {
            var days = dur.asDays().toFixed(0);
            result = `${days}:${result}`;
        }

        return (
            <div
                className='guest-list__timer'
                id={this.state.uuid}>

                {result}

            </div>
        );
    }
}

export default Timer;





// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/Timer.react.jsx